import React, { forwardRef } from 'react'

import Tooltip from '../Tooltip'

import * as S from './styles'

/**
 * @typedef {Object} TooltipProps
 * @property {string | React.ReactNode} label
 * @property {number | string} [width]
 */

/**
 * @typedef {Object} ActionIconProps
 * @property {string} icon
 * @property {'subtle' | 'filled' | 'outline' | 'light' | 'default' | 'transparent' | 'gradient'} [variant]
 * @property {'xs' | 'sm' | 'md' | 'lg' | 'xl' | number} [radius]
 * @property {string} alt
 * @property {(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void} [onClick]
 * @property {TooltipProps} [tooltip]
 * @property {number} [scaleIcon]
 */

/**
 * @typedef {HTMLButtonElement} ActionIconRef
 */

/**
 * @type {React.ForwardRefRenderFunction<ActionIconRef, ActionIconProps>}
 */
const ActionIconComponent = (
  {
    icon,
    variant = 'default',
    radius,
    alt,
    onClick,
    tooltip = {},
    scaleIcon = 1.5
  },
  ref
) => {
  const content = (
    <S.ActionIcon
      scale={scaleIcon}
      size="xs"
      onClick={onClick}
      variant={variant}
      radius={radius}
      ref={ref || null}
    >
      <img alt={alt} src={icon} />
    </S.ActionIcon>
  )

  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      {tooltip.label ? (
        <Tooltip
          opened
          width={tooltip.width || '150px'}
          withArrow
          transitionProps={{ duration: 200 }}
          label={tooltip.label}
        >
          {content}
        </Tooltip>
      ) : (
        content
      )}
    </div>
  )
}

const ActionIcon = forwardRef(ActionIconComponent)

ActionIcon.displayName = 'ActionIcon'

export default ActionIcon
